import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Trash2, ShoppingCart, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useFavorites } from '@/context/FavoritesContext';
import { useCart } from '@/context/CartContext';
import { ProductGrid } from '@/components/products/ProductGrid';

export const FavoritesPage = () => {
  const { favorites, removeFromFavorites, clearFavorites } = useFavorites();
  const { addToCart } = useCart();

  const handleAddAllToCart = () => {
    favorites.forEach(product => {
      if (product.inStock) {
        addToCart(product, 1);
      }
    });
  };

  if (favorites.length === 0) {
    return (
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-md mx-auto text-center">
            <div className="w-24 h-24 bg-muted rounded-full flex items-center justify-center mx-auto mb-6">
              <Heart className="h-12 w-12 text-muted-foreground" />
            </div>
            <h1 className="text-2xl font-bold text-foreground mb-4">Sem Favoritos</h1>
            <p className="text-muted-foreground mb-8">
              Ainda não adicionaste nenhum produto aos favoritos. Explora a nossa loja e guarda os teus produtos preferidos!
            </p>
            <Button asChild className="btn-festa">
              <Link to="/loja">
                Explorar Loja
                <ArrowRight className="h-4 w-4 ml-2" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      {/* Breadcrumb */}
      <div className="bg-muted/30 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center gap-2 text-sm text-muted-foreground">
            <Link to="/" className="hover:text-primary transition-colors">Início</Link>
            <span>/</span>
            <span className="text-foreground font-medium">Favoritos</span>
          </nav>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-foreground flex items-center gap-3">
              <Heart className="h-8 w-8 text-primary" />
              Os Meus Favoritos
            </h1>
            <p className="text-muted-foreground mt-1">
              {favorites.length} {favorites.length === 1 ? 'produto guardado' : 'produtos guardados'}
            </p>
          </div>

          <div className="flex gap-3">
            <Button 
              variant="outline" 
              onClick={clearFavorites}
              className="text-muted-foreground hover:text-destructive"
            >
              <Trash2 className="h-4 w-4 mr-2" />
              Limpar
            </Button>
            <Button onClick={handleAddAllToCart} className="btn-festa">
              <ShoppingCart className="h-4 w-4 mr-2" />
              Adicionar Todos
            </Button>
          </div>
        </div>

        <ProductGrid products={favorites} columns={4} />
      </div>
    </div>
  );
};

export default FavoritesPage;
